import { render, staticRenderFns } from "./SimpleTableCard.vue?vue&type=template&id=2950031d&scoped=true&"
import script from "./SimpleTableCard.vue?vue&type=script&lang=js&"
export * from "./SimpleTableCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2950031d",
  null
  
)

export default component.exports